import {Base} from './base'

/**
 * This api contains method used to
 * perform admin operations.
 */
class Admin extends Base
{
	/**
	 * Default constructor
	 * 
	 * @param {VuexStore} store vuex instance
	 */
	constructor(store)
	{
		return super(store)
	}

	/**
	 * Register using email and password
	 * Server responds with user object
	 * and JWT access token
	 * 
	 * @param {Object} data user data
	 * @return {Promise}
	 */
	register(data)
	{
		return this._post('/admin/register', data, true)
	}

	/**
	 * 
	 */
	deleteUser(userid)
	{
		return this._delete(`/admin/user/${userid}`)
	}

	/**
	 * Get list of registered users
	 */
	getUsers(offset = 0)
	{
		return this._get('/admin/users', {offset})
	}

	/**
	 * 
	 */
	subGuest(eventid, data)
	{
		if (data)
		{
			return this._post(`/admin/event/${eventid}/sub`, data, true)
		}
		else
		{
			return this._post(`/admin/event/${eventid}/sub`)
		}
	}

	/**
	 * 
	 */
	removeSub(eventid, userid)
	{
		return this._delete(`/admin/event/${eventid}/sub/${userid}`)
	}

	/**
	 *
	 */
	addProduct(userid, product)
	{
		return this._post(`/admin/user/${userid}/product`, product, true)
	}

	/**
	 *
	 */
	removeProduct(userid, prodid)
	{
		return this._delete(`/admin/user/${userid}/product/${prodid}`)
	}

	/**
	 *
	 */
	attachProduct(userid, eventid, prodid)
	{
		return this._put(`/admin/user/${userid}/${eventid}/product`, {product: prodid}, true)
	}

	/**
	 * 
	 */
	useProduct(userid, prodid, uses)
	{
		return this._put(`/admin/user/${userid}/${prodid}`, { uses }, true)
	}

	/**
	 * 
	 */
	toggleMembership(userid, enable)
	{
		return enable ? this._post(`/admin/user/${userid}/membership`) : this._delete(`/admin/user/${userid}/membership`)
	}
	/**
 	* Ottiene la lista delle iscrizioni alle small class di un utente
 	*/
	getUserClassSubscriptions(userid)
	{
		return this._get(`/admin/user/${userid}/class-subscriptions`)
	}
	/**
	 * Ottiene la classifica utenti (ranking) con supporto a paginazione
	 */
	getRanking(params)
	{
		return this._get('/admin/ranking', params)
	}
}

export default Admin